export default {
  targetLocation: 'Lieu cible',
  targetUser: 'Utilisateur cible',
  active: 'Actif',
  inactive: 'Inactif',
  createdAt: 'Créé le',
  noPermissions: 'Aucune permission assignée',
  // Types de permissions
  types: {
    LOCATION_MANAGEMENT: 'Gestion des lieux',
    BORROW_FOR_USER: 'Emprunter pour un utilisateur',
    RESOURCE_MANAGEMENT: 'Gestion des ressources'
  }
};
